<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      show-save-button
      unit="充值设置"
      edit-title
      form-label-width="60px"
      id-key="RechargeTempId"
      :data="data"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="金额" prop="Amount">
          <el-input v-model="data.Amount" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="Sort">
          <el-input v-model="data.Sort" v-int placeholder="请输入序号"></el-input>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RechargeTempId: 0,
        TempType: 1,
        Amount: null,
        Sort: 0,
      },
      isMB: this.$store.state.isMB,
      api: require("@/api/cp/rechargetemp").default,
      rules: {
        Amount: [{ required: true, message: "金额不能为空" }],
        Sort: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.api.getMaxSort(1).then((res) => {
        this.data.Sort = res.Data;
      });
    },
  },
};
</script>